export enum ScorePairingFlowSteps {
  START_PAIRING = 'start_pairing',
  STEP_1 = 'step_1',
  STEP_2 = 'step_2',
  STEP_3 = 'step_3',
  STEP_4 = 'step_4',
  STEP_5 = 'step_5',
  STEP_6 = 'step_6',
  USE_EXISTING_TEAM_STEP_1 = 'use_existing_team_step_1',
  USE_EXISTING_TEAM_STEP_2 = 'use_existing_team_step_2',
  USE_EXISTING_TEAM_STEP_3 = 'use_existing_team_step_3',
}

export enum ScoringPairEvents {
  PAIR_ISCORE_CLICKED = 'pair_iscore_clicked',
  UNPAIR_ISCORE_CLICKED = 'unpair_iscore_clicked',
  ISCORE_SCYNC_CLICKED = 'iscore_sync_clicked',
}

export interface StepperProps {
  onNext: () => void;
  title: string;
  children: React.ReactNode;
  step?: ScorePairingFlowSteps;
  overTitle: string;
  loading?: boolean;
}

export interface StartPairingProps {
  onTransfer: () => void;
  useExistingTeam: () => void;
}

export interface ScoreSettingsProps {
  teamId: string;
  teamHandle: string;
  teamPin: string | null;
  sportType?: string;
}

export interface ScorePairingFlowProps extends ScoreSettingsProps {
  onClose: () => void;
  step?: ScorePairingFlowSteps;
}
